<div class="app-container" [style.--sidenav-width]="sidenavWidth">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      #sidenav
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="isMenuOpen && showSidenav && !!currentUser"
      class="sidenav">

      <!-- Sidebar Header -->
      <div class="flex items-center gap-3 px-5 py-6 border-b border-white/10">
        <div class="w-9 h-9 bg-white/10 flex items-center justify-center">
          <mat-icon class="sidebar-logo-icon">sports_martial_arts</mat-icon>
        </div>
        <div>
          <div class="text-[15px] font-bold text-white leading-tight tracking-tight">{{ 'nav.app_name' | translate }}</div>
          <div class="text-[11px] text-white/50 font-normal">{{ 'nav.app_subtitle' | translate }}</div>
        </div>
      </div>

      <!-- Navigation -->
      <nav class="flex-1 px-3 py-4 space-y-1 overflow-y-auto sidebar-scrollbar">
        <ng-container *ngFor="let item of menuItems">
          <!-- Simple nav item -->
          <a *ngIf="!item.children && isMenuItemVisible(item)"
             [routerLink]="item.route"
             routerLinkActive="nav-active"
             class="nav-item group"
             (click)="isMobile && sidenav.close()">
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            <span class="nav-label">{{ item.label }}</span>
          </a>

          <!-- Expandable section -->
          <div *ngIf="item.children && isMenuItemVisible(item)">
            <button class="nav-item group w-full"
                    (click)="toggleMenuExpansion(item)">
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label flex-1 text-left">{{ item.label }}</span>
              <mat-icon class="expand-chevron" [class.rotate-180]="item.expanded">expand_more</mat-icon>
            </button>

            <!-- Sub-items -->
            <div class="sub-menu" [class.expanded]="item.expanded">
              <a *ngFor="let child of item.children"
                 [routerLink]="child.route"
                 routerLinkActive="nav-active"
                 class="nav-item nav-child group"
                 (click)="isMobile && sidenav.close()">
                <mat-icon class="nav-icon">{{ child.icon }}</mat-icon>
                <span class="nav-label">{{ child.label }}</span>
              </a>
            </div>
          </div>
        </ng-container>
      </nav>

      <!-- Sidebar Footer — Language Switcher -->
      <div class="px-4 py-3 border-t border-white/10">
        <div class="flex items-center gap-1.5 bg-white/5 rounded-lg p-1">
          <button class="flex-1 px-2 py-1.5 text-xs font-medium rounded-md transition-all text-center"
                  [class]="currentLang === 'uk' ? 'bg-white/15 text-white' : 'text-white/40 hover:text-white/60'"
                  (click)="switchLang('uk')">UK</button>
          <button class="flex-1 px-2 py-1.5 text-xs font-medium rounded-md transition-all text-center"
                  [class]="currentLang === 'en' ? 'bg-white/15 text-white' : 'text-white/40 hover:text-white/60'"
                  (click)="switchLang('en')">EN</button>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="main-content">
      <!-- Header -->
      <header class="sticky top-0 z-50 bg-white border-b border-border px-6 flex items-center justify-between h-16" *ngIf="currentUser">
        <div class="flex items-center gap-4">
          <button class="btn-tw p-2 -ml-2 rounded-lg text-text-secondary hover:bg-surface-tertiary hover:text-text-primary transition-colors"
                  (click)="toggleMenu()"
                  *ngIf="showSidenav">
            <mat-icon>menu</mat-icon>
          </button>
          <h1 class="text-base font-semibold text-text-primary" style="margin: 0 !important">{{ getPageTitle() }}</h1>
        </div>

        <div class="flex items-center gap-3">
          <!-- User Menu -->
          <button class="btn-tw flex items-center gap-2.5 pl-1 pr-3 py-1.5 rounded-lg hover:bg-surface-tertiary transition-colors"
                  [matMenuTriggerFor]="userMenu">
            <div class="w-8 h-8 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center">
              <mat-icon class="user-avatar-icon">person</mat-icon>
            </div>
            <div class="hidden sm:flex flex-col items-start leading-tight">
              <span class="text-sm font-medium text-text-primary">{{ getUserDisplayName() }}</span>
              <span class="text-[11px] text-text-muted capitalize">{{ getUserRole() }}</span>
            </div>
            <mat-icon class="chevron-icon text-text-muted">expand_more</mat-icon>
          </button>

          <mat-menu #userMenu="matMenu">
            <button mat-menu-item routerLink="/profile">
              <mat-icon>person</mat-icon>
              <span>{{ 'nav.my_profile' | translate }}</span>
            </button>
            <button mat-menu-item routerLink="/settings">
              <mat-icon>settings</mat-icon>
              <span>{{ 'nav.settings' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>{{ 'nav.logout' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </header>

      <!-- Main content -->
      <div class="content-body" [class.auth-page]="isAuthPage">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
